import { render, staticRenderFns } from "./expertise.vue?vue&type=template&id=ffa10e86&scoped=true"
import script from "./expertise.vue?vue&type=script&lang=js"
export * from "./expertise.vue?vue&type=script&lang=js"
import style0 from "./expertise.vue?vue&type=style&index=0&id=ffa10e86&prod&lang=less&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa10e86",
  null
  
)

export default component.exports